import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {SharedService} from '../../../shared/shared.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from 'angular-2-local-storage';
import {MatExpansionPanel, MatRadioChange} from '@angular/material';
import {PaymentusPaymentOptions} from '../payment.options';

declare var $: any;

const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const DATE_REGEX = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;

export interface PaymentMethod {
  id: number;
}

@Component({
  selector: 'app-view-payment-methods',
  templateUrl: './view-payment-methods.component.html',
  styleUrls: ['./view-payment-methods.component.css']
})
export class ViewPaymentMethodsComponent implements OnInit {
  isLoading = false;
  isAddingNewPaymentMethod = false;
  selectedPayment = undefined;
  isExpressPay = false;
  @Input() currentPayment = undefined;
  @Input() initNewPayment = false;
  @Input() paymentMethods: any[] = [];
  @Input() isSelectPaymentMethod = false;
  @Input() allowCreatingNewPaymentMethod = false;
  @Input() displayBackButton = false;
  @Output() backOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectPaymentMethodOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPaymentMethodsUpdated: EventEmitter<any> = new EventEmitter<any>();
  protected readonly PaymentusPaymentOptions = PaymentusPaymentOptions;
  constructor(
    private sharedService: SharedService,
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {
	  this.isExpressPay = this.localStorageService.get('is_express_pay')
  }

  ngOnInit() {
    if (this.initNewPayment) {
      this.isAddingNewPaymentMethod = true;
    }

    this.selectedPayment = this.currentPayment;
    console.log(this.selectedPayment)
  }
  onChange(radio: MatRadioChange, panel: MatExpansionPanel) {
    panel.open();
  }
  getPaymentOption(type: string) {
    return this.PaymentusPaymentOptions.find((x) => (x.category === 'DD' && type === '')
      || (x.category === 'DC' && type.includes('DEBIT'))
      || (x.category === 'CC' && type.includes('CREDIT'))
    )
  }
  paymentMethodAdded(paymentMethods: any) {
    this.isAddingNewPaymentMethod = false;
    this.paymentMethods = paymentMethods;
    this.onPaymentMethodsUpdated.emit(paymentMethods)
	  if (this.isExpressPay) {
		  if (this.paymentMethods && this.paymentMethods.length > 0) {
			  this.selectPaymentMethod(this.paymentMethods[0]);
		  }
		  this.backOutputEmit();
	  }
  }
  handleBackOut() {
    if (this.isAddingNewPaymentMethod) {
      this.isAddingNewPaymentMethod = false;
    } else {
      this.backOutputEmit();
    }
  }
  backOutputEmit() {
    this.backOutput.emit();
  }
  selectPaymentMethod(paymentMethod: any) {
    console.log(paymentMethod)
    this.selectPaymentMethodOutput.emit(paymentMethod);
  }
  isCard(type: string) {
    return type.includes('CREDIT') || type.includes('DEBIT') || type.includes('MC') || type.includes('MASTERCARD') || type.includes('VISA') || type.includes('AMEX') || type.includes('DISC')
  }
  isBank(type: string) {
    return type.includes('CHQ') || type.includes('SAV') || type === 'DD'
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/view-payment-methods/view-payment-methods.component.ts